import { createApp } from '@app/adapters/create-app'

import VirusScanningModal from '../handlers/virus-scanning-modal'

onDomLoad(() => {
  window.eventHub.$on('virus-scan-modal-opened', () => {
    const element = document.getElementById('virus-scanning')

    if (element) {
      createApp(VirusScanningModal, {
        ...element.dataset,
      }).mount(element)
    }
  })
})
